import { useContext } from 'react';
import AccountContext from 'context/AccountContext';
import { isSalesOrderActive, isSalesOrderWaiting } from 'utils/permitUtils';

const useUserPermitOrderLine = (orderLineIdWithVersion: string | undefined) => {
  const {
    customer: { permits },
  } = useContext(AccountContext);

  return permits?.find(
    (permit) =>
      permit &&
      (isSalesOrderActive(permit) || isSalesOrderWaiting(permit)) &&
      permit.orderLineIdWithVersion === orderLineIdWithVersion
  )?.orderLines?.[0];
};

export default useUserPermitOrderLine;
